export default "__VITE_ASSET__54da2282__"